import { style } from '@vanilla-extract/css'

import { getFontSize } from '~/styles/mixins/font.css'
import { getMediaQuery } from '~/styles/mixins/mediaQuery.css'
import { getTransition } from '~/styles/mixins/transition.css'
import { gradationPrimaryDark } from '~/styles/variables/color.css'
import { cssVariables } from '~/styles/variables/cssVariables.css'

export const layoutSideMenu = style({
  minWidth: 230,
  width: 230,
  height: '100%',
  overflowY: 'auto',
})

export const layoutSideMenu_container = style({
  paddingBottom: 80,
})

export const layoutSideMenuLogo = style({
  paddingTop: 32,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
})

export const layoutSideMenuLogo_link = style({
  selectors: {
    '&:not(:root)': {
      display: 'flex',
      alignItems: 'center',
    },
  },

  '@media': {
    [getMediaQuery('hover')]: {
      selectors: {
        '&:not(:root):hover': {
          opacity: cssVariables.opacity.hover,
        },
      },
    },
  },
})

export const layoutSideMenuLogo_image = style({
  width: 164,
  height: 'auto',
})

export const layoutSideMenuCompany = style({
  marginTop: 32,
  paddingBottom: 32,
  borderBottom: `1px solid ${cssVariables.color.corduroy.hex}`,
})

export const layoutSideMenuCompany_container = style({})

export const layoutSideMenuCompanyLink = style({
  selectors: {
    '&:not(:root)': {
      display: 'block',
      textDecoration: 'none',
      textAlign: 'center',
      color: cssVariables.color.white.hex,
      fontSize: getFontSize(14),
      fontWeight: cssVariables.font.weight.bold,
      padding: '0 24px',
    },
  },

  '@media': {
    [getMediaQuery('hover')]: {
      selectors: {
        '&:not(:root):hover': {
          color: cssVariables.color.shamrockDark.hex,
        },
      },
    },
  },
})

export const layoutSideMenuCompanyLink_container = style({})

export const layoutSideMenuCompanyLink_icon = style({
  margin: '0 auto',
  border: `1px solid ${cssVariables.color.blackHaze.hex}`,
  transition: getTransition([
    {
      property: 'border-color',
    },
  ]),

  '@media': {
    [getMediaQuery('hover')]: {
      selectors: {
        [`${layoutSideMenuCompanyLink}:hover &`]: {
          borderColor: cssVariables.color.shamrockDark.hex,
        },
      },
    },
  },
})

export const layoutSideMenuCompanyLink_text = style({
  display: 'block',
  marginTop: 16,
})

export const layoutSideMenuMainNavigation = style({})

export const layoutSideMenuMainNavigation_navigation = style({})

export const layoutSideMenuMain = style({
  backgroundColor: cssVariables.color.capeCod.hex,
})

export const layoutSideMenuMain_items = style({})

export const layoutSideMenuMain_item = style({})

export const layoutSideMenuMain_container = style({})

export const layoutSideMenuMainLink = style({
  selectors: {
    '&:not(:root)': {
      display: 'flex',
      padding: '16px 24px',
      textDecoration: 'none',
      color: cssVariables.color.white.hex,
      fontSize: getFontSize(14),
      fontWeight: cssVariables.font.weight.bold,
    },
  },

  '@media': {
    [getMediaQuery('hover')]: {
      selectors: {
        '&:not(:root):hover': {
          backgroundColor: cssVariables.color.hintOfGreen.hex,
        },
      },
    },
  },
})

export const layoutSideMenuMainLink_icon = style({
  flexShrink: 0,
  marginRight: 16,

  '@media': {
    [getMediaQuery('hover')]: {
      selectors: {
        [`${layoutSideMenuMainLink}:hover &`]: {
          background: `linear-gradient(90deg, ${gradationPrimaryDark})`,
        },
      },
    },
  },
})

export const layoutSideMenuMainLink_text = style({
  display: 'inline-block',

  '@media': {
    [getMediaQuery('hover')]: {
      selectors: {
        [`${layoutSideMenuMainLink}:hover &`]: {
          background: `linear-gradient(90deg, ${gradationPrimaryDark})`,
          WebkitBackgroundClip: 'text',
          backgroundClip: 'text',
          WebkitTextFillColor: 'transparent',
        },
      },
    },
  },
})

export const layoutSideMenuSub = style({
  marginTop: 8,
})

export const layoutSideMenuSub_items = style({})

export const layoutSideMenuSub_item = style({})

export const layoutSideMenuSub_container = style({})

export const layoutSideMenuSubLink = style({
  selectors: {
    '&:not(:root)': {
      display: 'block',
      padding: '12px 24px',
      textDecoration: 'none',
      color: cssVariables.color.white.hex,
      fontSize: getFontSize(12),
      position: 'relative',
      width: '100%',
      textAlign: 'left',
      borderRadius: 0,
      border: 'none',
      backgroundColor: 'transparent',
      transition: getTransition([
        {
          property: 'color',
        },
      ]),
    },

    '&:after': {
      content: '',
      position: 'absolute',
      width: 'calc(100% - 24px)',
      height: 1,
      bottom: 0,
      right: 0,
      backgroundColor: cssVariables.color.corduroy.hex,
    },
  },

  '@media': {
    [getMediaQuery('hover')]: {
      selectors: {
        '&:not(:root):hover': {
          color: cssVariables.color.shamrockDark.hex,
        },
      },
    },
  },
})

export const layoutSideMenuSubLink_text = style({
  display: 'block',
})
